import appendScript from 'helpers/appendScript';
import { addItemToCart, updateItemInCart } from 'modules/bambuser/basket';
import isClient from 'helpers/isClient';
import provideProductDataFunction from '../productData';
import { EventType } from './types';
import provideSearchData from '../eventListeners/provideSearchData';

export async function appendOneToOneScript() {
    const scriptId = 'bambuser_one_to_one_script';
    const scriptUrl = 'https://one-to-one.bambuser.com/eu/embed.js';

    return appendScript({ url: scriptUrl, async: true, id: scriptId });
}

export function openOneToOneInstance() {
    const organizationId = 'wWQVmNxhJtkCslBhue5l';

    window.onBambuserOneToOneReady = (BambuserOneToOneEmbed) => {
        const embed = new BambuserOneToOneEmbed({
            orgId: organizationId,
            currency: 'DKK',
            locale: 'da-DK',
            enableScanning: true
        });
        embed.on('provide-product-data', (event: EventType) => {
            event.products.forEach((bambuserProduct) => provideProductDataFunction(bambuserProduct, embed));
        });
        embed.on('should-add-item-to-cart', (item, callback) => {
            addItemToCart(item, 'BambuserOneToOne', callback);
        });
        embed.on('should-update-item-in-cart', (item, callback) => {
            updateItemInCart(item, 'BambuserOneToOne', callback);
        });
        embed.on('goto-checkout', () => {
            window.open(`${window.location.origin}${window.AddAndRemoveFromBasket.getBasketUrl()}`, '_blank');
        });
        embed.on('provide-search-data', (searchRequest, searchResponse) => {
            provideSearchData(searchRequest, searchResponse);
        });

        window.oneToOneEmbed = embed;
    };
}

const oneToOneSetupAndOpen = async () => {
    if (!isClient) return;

    if (window.oneToOneEmbed) {
        window.oneToOneEmbed.show();
    } else {
        appendOneToOneScript().then(openOneToOneInstance);
    }
};

export default oneToOneSetupAndOpen;
